<div class="row" [class.hidden]="filteredCities?.length <= 1 && !opened">
  <div class="inputWrapper" (click)="open()" [class.shown]="isInputShown()">
    <input
      type="text"
      class="search"
      #search
      [(ngModel)]="filterValue"
      (ngModelChange)="onSearch($event)"
      placeholder="{{ 'Search a city' | translate }}"
    />
  </div>
  <button [class.selected]="selected" class="button" (click)="toggle()">
    <span class="spacer"></span>
    <div
      class="generic-tooltip"
      [attr.data-tooltip]="'Search a city' | translate"
    ></div>
  </button>
</div>
<div class="filter custom-scrollbar">
  <ul *ngIf="filteredCities?.length; else nodataTemplate">
    <li
      *ngFor="let item of filteredCities"
      (click)="onChange(item)"
      [class.selected]="isSelected(item)"
    >
      {{ item.name }}
    </li>
  </ul>
  <ng-template #nodataTemplate>
    <div class="nodata">
      {{ 'No data' | translate }}
    </div>
  </ng-template>
</div>
